import ADIColors from "@NA/Utils/ADIColors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    brandName: string;
    brandUrl: string;
    extendedStyles?: ADIProductBrandNameStyles;
}

type Props = OwnProps;

export interface ADIProductBrandNameStyles {
    nameLink?: LinkPresentationProps;
    nameText?: TypographyProps;
}

const nameText: TypographyProps = {
    css: css`
        width: 100%;
        color: ${ADIColors.darkBlack3};
        ${wrapInContainerStyles}
        &:hover {
            text-decoration: underline;
        }
    `,
    size: "13px",
    weight: 600,
};

export const adiProductBrandNameStyles: ADIProductBrandNameStyles = {
    nameText,
    nameLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: nameText,
    },
};

const ADIProductBrandName: FC<Props> = ({ brandName, brandUrl, extendedStyles }) => {
  

    const [styles] = React.useState(() => mergeToNew(adiProductBrandNameStyles, extendedStyles));
   
    if (!brandName) {
        return null;
    }
    
    let brandDisplay;
    brandDisplay = <Typography {...styles.nameText} data-test-selector="adiBrandName">
            {brandName}
        </Typography>;

    return brandUrl ? (
        <Link {...styles.nameLink} href={brandUrl} data-test-selector="brandLink">
            {brandDisplay}
        </Link>
    ) : (
        <>{brandDisplay}</>
    );
};

export default ADIProductBrandName;
